import { ACTIONS_ACCOUNT } from '_constants/account.constants';
import { accountService } from '_services';
import { session } from '_helpers';
import alertActions from './alert.actions';

export const receiveAccounts = (accounts) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < accounts.length; i++) {
    byIdObjectToDispatch[accounts[i].accountID] = accounts[i];
  }

  return {
    type: ACTIONS_ACCOUNT.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteAccount = (accountId) => ({
  type: ACTIONS_ACCOUNT.DELETE,
  byId: { [accountId]: null }
});

const getAccounts = () => async (dispatch) => {
  try {
    const resp = await accountService.getAll();
    if (resp?.dealers || resp?.clients || resp?.supports) {
      const accounts = [
        ...(resp.dealers ?? []),
        ...(resp.clients ?? []),
        ...(resp.supports ?? [])
      ];
      dispatch(receiveAccounts(accounts));
      return accounts;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving accounts.'));
  }
  return null;
};

const getDealers = () => async (dispatch) => {
  try {
    const resp = await accountService.getDealers();
    if (resp?.accounts) {
      dispatch(receiveAccounts(resp.accounts));
      return resp.accounts;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving dealers.'));
  }
  return null;
};

const getAccount = (accountID) => async (dispatch) => {
  try {
    if (!accountID) {
      return null;
    }
    const resp = await accountService.getById(accountID);
    if (resp?.accountID) {
      dispatch(receiveAccounts([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving account #${accountID}.`));
  }
  return null;
};

const addAccount = (account) => async (dispatch) => {
  try {
    const resp = await accountService.create(account);
    if (resp?.accountID) {
      dispatch(receiveAccounts([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updAccount = (account) => async (dispatch) => {
  try {
    const resp = await accountService.update(account);
    if (resp?.accountID) {
      dispatch(receiveAccounts([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delAccount = (accountID) => async (dispatch) => {
  try {
    const resp = await accountService.delete(accountID);
    if (resp?.accountID) {
      dispatch(deleteAccount(resp?.accountID));
      dispatch(alertActions.success('Account successfully deleted.'));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing account #${accountID}.`));
  }
  return null;
};

const accountActions = {
  getAccounts,
  getAccount,
  addAccount,
  updAccount,
  delAccount,
  getDealers
};

export default accountActions;
